/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import { useAxios } from "@/hooks";
import { endPoint } from "@/utils";

const useSearchAddress = () => {
    const { fetchData, response }: any = useAxios();

    const handleSearch = async (text: string) => {
        if (text?.trim() === "") return;
        if (text?.trim()?.length > 2) {
            await fetchData({
                url: endPoint.SEARCH_LOCATION_API,
                method: "POST",
                data: {
                    queryString: text,
                },
            });
        }
    };

    const handleAddressSelect = async (placeId: string, onAddressSelect: (address: any) => void) => {
        const addressdata = await fetchData({
            url: endPoint.ADDRESS_LOCATION_API,
            method: "POST",
            data: {
                placeId
            },
        });
        onAddressSelect(addressdata.data);
    }

    /**
     * The suggestion list, whichever name it arrives under.
     *
     * The backend answers `{ suggestions }` with the fields already renamed
     * (`placeId`, `mainText`); the previous one passed Ola's own body through
     * as `{ predictions }` with `place_id` and `structured_formatting`. Both
     * are normalised here so the components below know one shape.
     */
    const suggestions = (
        response?.data?.suggestions ??
        response?.data?.predictions ??
        []
    ).map((row: any) => ({
        ...row,
        placeId: row?.placeId ?? row?.place_id,
        description: row?.description,
        mainText: row?.mainText ?? row?.structured_formatting?.main_text,
        secondaryText:
            row?.secondaryText ?? row?.structured_formatting?.secondary_text,
    }));

    return {
        data: suggestions,
        handleSearch,
        handleAddressSelect,
    };
}

export default useSearchAddress;
